import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorBoundary from '../ErrorBoundary';


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const ReactiveFilter = props => (
    <Filter {...props}>
        
        <DateInput source="bleed_date" alwaysOn lable='Bleeding Date' locales="en-us"/>
        
       
    </Filter>
);

export const ReactiveList = props => (
    <ErrorBoundary>
    <List 
        {...props}
        filters={<ReactiveFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'ASC' }}
        bulkActionButtons ={false}
        title={'Reactive logs'}
        >
        <Datagrid >
            <DateField source="bleed_date" label="Bleeding Date" locales="en-us"/>  
            <TextField source="ssn" label="Donor #"  />
            <TextField source="ucn" label="Control#" />
            <TextField source="comments" label="Reason"/>
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default ReactiveList
